import api, { isMockEnabled } from './axiosConfig';
import { CONTACT_ENDPOINT } from './apiEndpoints';
import { logError } from './errorLogService';

const mockContactData =
{
    email: 'contactus@rainbowagro.com',
    phone: '+86 531 88875231',
    location_text: '30th floor, Hanyu Financial Centre, Building A5-5, No.7000 Jingshi Road, Jinan, shandong, China 250101',
    location_latitude: '36.672823',
    location_longitude: '117.154753',
};

export const fetchContact = async (countryId = 1) => {
    if (isMockEnabled) {
        return mockContactData; // Usa datos mock si está activado
    }

    try {
        const response = await api.get(CONTACT_ENDPOINT(countryId));
        return response.data;
    } catch (error) {
        console.error("Error fetching hero data", error);

        await logError('contact_data_fetch', error, {
            endpoint: CONTACT_ENDPOINT(countryId),
            countryId,
            response_status: error.response?.status,
            response_data: error.response?.data,
        });

        throw error;
    }
};
export const postEmailContact = async (countryId = 1, data) => {
    try {
        const response = await api.post(CONTACT_ENDPOINT(countryId), data);
        return response.data;
    } catch (error) {
        console.error("Error sending email", error);

        await logError('contact_email_send', error, {
            endpoint: CONTACT_ENDPOINT(countryId),
            countryId,
            response_status: error.response?.status,
            response_data: error.response?.data,
        });

        throw error;
    }
};
